import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactFormSection from './components/ContactFormSection';
import HeroSection from './components/HeroSection';
import DualEngineSolutions from './components/DualEngineSolutions';
import HowWeWork from './components/HowWeWork';
import PricingSection from './components/PricingSection';
import SystemFeaturesSection from './components/SystemFeaturesSection';
import HomeFAQSection from './components/HomeFAQSection';
import LiveDemoSection from './components/LiveDemoSection';
import { useNavigate } from 'react-router-dom';

const scrollToForm = () => {
  try {
    const el = document.getElementById('contact-form');
    if (!el) return;
    if (typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  } catch (error) {
    console.error('scrollToForm: unexpected error', error);
  }
};

export default function HomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = '全鏈獲客整合行銷 - 自動化行銷漏斗 | B2B 精準獲客解決方案';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', '全鏈獲客整合行銷為高總價 B2B、電商與實體店家打造全自動印鈔漏斗。透過痛點影音引流、精準廣告投放與 API 自動化系統串接，量身打造防禦型或極速轉換漏斗，極大化廣告投報率 ROAS。');

    const scriptId = 'jsonld-home';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      script.text = JSON.stringify([
        {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '全鏈獲客整合行銷',
          url: import.meta.env.VITE_SITE_URL || 'https://example.com',
          description: '為高總價 B2B、電商與實體店家打造全自動印鈔漏斗，量身打造防禦型或極速轉換漏斗。',
          potentialAction: {
            '@type': 'SearchAction',
            target: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/?q={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
        },
        {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '全鏈獲客整合行銷',
          url: import.meta.env.VITE_SITE_URL || 'https://example.com',
          logo: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/vite.svg`,
          contactPoint: {
            '@type': 'ContactPoint',
            email: 'fullchainmarketing@gmail.com',
            contactType: 'customer service',
            availableLanguage: 'zh-TW',
          },
          sameAs: [],
        },
        {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          '@id': `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#webpage`,
          url: import.meta.env.VITE_SITE_URL || 'https://example.com',
          name: '全鏈獲客整合行銷 - 自動化行銷漏斗 | B2B 精準獲客解決方案',
          description: '從痛點影音引流、精準廣告投放，到 API 自動化系統串接，為您的產業量身打造專屬的獲客生產線。',
          inLanguage: 'zh-TW',
          isPartOf: { '@id': `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#website` },
        },
        {
          '@context': 'https://schema.org',
          '@type': 'ProfessionalService',
          name: '全鏈獲客整合行銷',
          url: import.meta.env.VITE_SITE_URL || 'https://example.com',
          description: '專精企業 O2O 整合系統建置與頂級全鏈獲客代操，為企業主打造從內部防呆到全鏈路廣告的數位自動印鈔機。',
          email: 'fullchainmarketing@gmail.com',
          areaServed: { '@type': 'Country', name: 'TW' },
          availableLanguage: { '@type': 'Language', name: 'Chinese Traditional' },
          serviceType: ['B2B 精準獲客', '自動化行銷漏斗建置', 'O2O 數位管理系統', '廣告代操服務', '數據追蹤埋設'],
          priceRange: '$$$$',
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: '全鏈獲客整合服務目錄',
            itemListElement: [
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '企業 O2O 系統建置', description: '打造企業專屬防呆管理與 O2O 展間系統。' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '自動化行銷漏斗', description: '防禦型或極速轉換型漏斗策略規劃與建置。' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '廣告精準代操', description: '多渠道廣告合規投放與持續 ROAS 優化。' } },
            ],
          },
        },
      ]);
      document.head.appendChild(script);
    }
    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar onConsultClick={scrollToForm} />
      <HeroSection onCTAClick={scrollToForm} onLearnMore={() => { navigate('/services'); window.scrollTo({ top: 0, behavior: 'smooth' }); }} />
      <LiveDemoSection onCTAClick={scrollToForm} />
      <HowWeWork onCTAClick={scrollToForm} />
      <SystemFeaturesSection onCTAClick={scrollToForm} />
      <DualEngineSolutions onCTAClick={scrollToForm} />
      <PricingSection onCTAClick={scrollToForm} />
      <HomeFAQSection onCTAClick={scrollToForm} />
      <ContactFormSection />
      <Footer />
    </div>
  );
}
